import Vue from 'vue'
import App from '@/App.vue'
// Trigger redeployment
// import Bugsnag from '@bugsnag/js'
// import BugsnagPluginVue from '@bugsnag/plugin-vue'
//
// Bugsnag.start({
//     apiKey: '9999896a89acbde86fded5c67c7349a7',
//     plugins: [new BugsnagPluginVue()]
// })
//
// Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)

require('dotenv').config();

import Laraform from "laraform";
Vue.use(Laraform);

import 'Components'
import '@/registerServiceWorker'
import router from '@/router'
import store from '@/vuex/store';

window.Vue = Vue;

// Boostrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);


// Moment
import moment from 'moment'

Vue.prototype.moment = moment

//User
import User from "./services/user";
let user = new User(store.getters.user);

// VueAxios
import Axios from 'axios'
let axios = Axios.create({
    baseURL:process.env.VUE_APP_API_URI
});
axios.interceptors.request.use((config) => {
    config.params = config.params || {};
    config.params['key'] = user.apiKey();

    // If we already have an authorization header, skip.
    if (config.headers.Authorization !== undefined
        && config.headers.Authorization !== null
        && config.headers.Authorization.length > 0) {
        return config;
    }

    // If we have a user with an api key in store, lets apply that key to all requests,
    //  regardless of whether it's needed or not.
    const token = user.apiKey();
    if (token !== null) {
        config.headers.Authorization = 'Bearer ' + token;
    }

    return config;
});
Vue.prototype.$http = axios;
store.$axios = axios;

// Vue Offline
import VueOffline from 'vue-offline';
Vue.use(VueOffline);

// Vue Scrollto
let VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease-in",
    offset: -20,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

// Vue Signature Pad
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

// Vue Toasted
import VueToasted from 'vue-toasted';
Vue.use(VueToasted, {
    iconPack : 'custom-class' // set your iconPack, defaults to material. material|fontawesome|custom-class
});

// Firebase
let firebase = require('firebase/app');
firebase.firestore().enablePersistence({ synchronizeTabs: true }).catch(() => {});

// Firestore is closed to unauthenticated callers, so restore the Firebase
// session before anything is allowed to render. The router holds navigation on
// the same gate, so no screen - and therefore no Firestore read or write - runs
// until this has settled one way or the other.
import firebaseAuth from '@/services/firebaseAuth';

const returnToLogin = () => {
    store.dispatch('clearUser');
    firebaseAuth.signOut();

    if (router.currentRoute.name !== 'login') {
        router.replace('/login').catch(() => {});
    }
};

firebaseAuth.signIn()
    .then(user => {
        // signIn() resolves with null when there was no API key to exchange, so
        // no token was ever requested. That means the stored session is gone -
        // local storage evicted, or a browser that never had one - and Firestore
        // will refuse every read. Treat it exactly like a failed sign-in.
        if (!user) {
            returnToLogin();
        }
    })
    .catch(error => {
        // Firestore is closed to unauthenticated callers, so a session we could
        // not establish is a dead session rather than a degraded mode to carry
        // on in - every read would be denied. 401 means the Laravel session is
        // gone, 403 means this user may not hold a Firebase credential at all,
        // and anything else has already survived the retries in the auth
        // service. Login is the one screen that works without Firestore.
        if (!firebaseAuth.isAccessDenied(error)) {
            console.error('Could not establish a Firebase session.', error);
        }

        returnToLogin();
    });

import './registerServiceWorker'
import '@/styles/imports.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
